module.exports = __webpack_public_path__ + "static/media/logo-icons.beb6a98d.svg";